import { ROLES } from "../../../const"
import type { ApiRoleStrategy } from "../../../hooks"

const uppConf = (pharmacyId: string) => ({
  endpoint: `/api/financial-data/president/pharmacies/${pharmacyId}/purchases`,
  queryKey: ["financial-data", "president", "pharmacies", pharmacyId, "purchases"],
})

const adhConf = {
  endpoint: "/api/financial-data/adherent/purchases",
  queryKey: ["financial-data", "adherent", "purchases"],
}

export const financialDataPurchasesRoleConf = (
  pharmacyId?: string,
): ApiRoleStrategy => ({
  [ROLES.ADHERENT_TEAM]: adhConf,
  [ROLES.ADHERENT_HOLDER]: adhConf,
  ...(pharmacyId && {
    [ROLES.UPP_PRESIDENT]: uppConf(pharmacyId),
    [ROLES.UPP_REPRESENTATIVE]: uppConf(pharmacyId),
    [ROLES.ADMIN]: {
      endpoint: `/api/financial-data/pharmacies/${pharmacyId}/purchases`,
      queryKey: ["financial-data", "pharmacies", pharmacyId, "purchase"],
    },
    [ROLES.ADHERENT_ADVISOR]: {
      endpoint: `/api/financial-data/advisor/pharmacies/${pharmacyId}/purchases`,
      queryKey: ["financial-data", "advisor", "pharmacies", pharmacyId, "purchases"],
    },
  }),
})
